import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Wraps a page so it requires login, and optionally a specific role.
// Both doctor and receptionist authenticate through the same login page;
// this component then gates access based on the role stored in the token.
export default function ProtectedRoute({ children, allowedRoles }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ fontSize: 14, color: 'var(--color-ink-faint)' }}>Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Logged in, but wrong portal - redirect to their correct home
    return <Navigate to={user.role === 'doctor' ? '/doctor' : '/receptionist'} replace />;
  }

  return children;
}
